<template>
  <div class="exhibition">
    <div class="details">
       <div class="item" v-for="(news, index) in newsList" :key="news.date + '-' + index">
        <div class="news-top-img">
          <img :src="news.banner" alt="" @click="viewNewsDetail(news)">
        </div>
        <div class="date">
          <v-icon name="calendar" class="icon"/>
          {{getRealDate(news.date)}}
        </div>
        <div class="describe">
          <span class="caption" @click="viewNewsDetail(news)">{{news.title}}</span>
          <span class="author">
            <span class="unique">{{news.author}}</span>
          </span> 
          <p class="content">{{news.desc}}</p>
          <!-- :to="{name:'newsDetails', params:{title: news.title, date: news.date, author: news.author, banner: news.banner, page: news.page}}" -->
          <a @click="viewNewsDetail(news)" class="more">
            阅读更多
            <v-icon name="arrow-right" class="icon" scale="0.7"/>
          </a>
        </div>
      </div>
    </div>
    <!-- <div class="page">
      <a href="javascript:;" class="page-item">上一页</a>
      <a href="javascript:;" class="page-item">1</a>
      <a href="javascript:;" class="page-item">2</a>
      <a href="javascript:;" class="page-item">3</a>
      <a href="javascript:;" class="page-item">下一页</a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'News',
  data () {
    return {
      newsList: []
    }
  },
  methods: {
    getRealDate(timestamp) {
      let date = new Date(timestamp)
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
    },
    viewNewsDetail(news) {
      localStorage.setItem('currentNews', JSON.stringify(news))
      this.$router.push('/news/newsDetails')
    }
  },
  mounted () {
    this.axios.get('../news/news.json')
      .then(res => {
        let newsList = res.data
        if (!newsList && newsList.length === 0) {
          return
        }
        this.newsList = newsList || []
        localStorage.setItem('newsList', JSON.stringify(newsList))
      })
      .catch(() => {
        let newsCache = localStorage.getItem('newsList')
        this.newsList = newsCache ? JSON.parse(newsCache) : []
      })
  }
}
</script>

<style lang="scss" scoped>
@mixin news-image {
  height: 236px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  overflow: hidden;
  &:hover {
    cursor: pointer;
  }
}

a {
  text-decoration: none;
  transition: .5s;
}

.exhibition {
  margin: 0 auto;
}

.title {
  width: 100%;
  padding: 140px 0 130px;
  margin-top: 65px;
  background: url('../../assets/img/banner-bg1.jpg') center no-repeat;

  .content {
    font-size: 24px;
    font-weight: 700;
    color: #0e314c;
  }
}

.details {
  @media (max-width: 576px) {
    max-width: 540px;
    padding-right: 0px;
    padding-left: 0px;
  }

  @media (min-width: 768px) {
    max-width: 740px;
  }

  @media (min-width: 992px) {
    max-width: 880px;
  }
  
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  padding: 80px 0 20px;

  .item {
    width: 320px;
    margin: 0 15px 30px;
    position: relative;
    transition: .5s;

    &:hover {
      box-shadow: 0 0 40px 0 #d8dde6;

      .describe {
        background: #fff;
      }
    }
    .news-top-img{
      width: 320px;
      height: 236px;

      img {
        object-fit: cover;
        width: inherit;
        height: inherit;
        
        &:hover {
          cursor: pointer;
        }
      }
    }
    

    .date {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);
      padding: 8px 16px;
      border-radius: 50px;
      height: 24px;
      font-size: 13px;
      color: #fff;
      left: 35px;
      top: 215px;

      .icon {
        width: 15px;
        height: 24px;
        margin-right: 5px;
      }
    }

    .describe {
      padding: 40px 20px 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 13px;
      background: #f7fafd;
      transition: .5s;

      .caption {
        width: 100%;
        text-align: left;
        color: #0e314c;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;

        &:hover {
          cursor: pointer;
          color: #44ce6f;
        }
      }

      .author {
        margin: 15px 0;
        color: #0e314c;

        .unique {
          margin-left: 2px;
          color: #6084a4;
          font-weight: bold;
          font-style: italic;

          &:hover {
            color: #44ce6f;
          }
        }
      } 

      .content {
        text-align: left;
        margin: 0 0 16px;
        color: #6084a4;
        line-height: 1.9;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .more {
        color: #0e314c;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          color: #44ce6f;

          .icon{
            margin-left: 10px;
          }
        }

        .icon {
          margin-left: 5px;
          transition: .3s;
        }
      }
    }
  }

  // @media (max-width: 745px) {
  //   .item {
  //     width: 100%;
  //   }
  // }

  // @media (max-width: 1024px) {
  //   width: 100%;

  //   .item {
  //     img {
  //       width: 100%;
  //     }
  //   }
  // }

  // @media (min-width: 768px) and (max-width: 1023px) {
  //   max-width: 720px;
  //   margin: 0 24px;
  //   display: flex;
  //   justify-content: center;
  //   flex-wrap: wrap;

  //   .item {
  //     width: 330px;
  //     margin: 0 15px 30px;
  //   }
  // }

  // @media (width: 1024px) { 
  //   .item {
  //     width: 290px;
  //     margin: 0 15px 30px;
  //   }
  // }

  // @media (min-width: 1025px) {
  //   max-width: 1140px;
  // }
}

.page {
  width: 930px;
  height: 89px;
  margin: 0 auto;
  padding: 0 15px 50px;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    width: 100%;
  }

  .page-item {
    display: inline-block;
    padding: 11px 20px;
    box-shadow: 0 2px 10px 0 #d8dde6;
    color: #6f8ba4;
    border: none;

    &:nth-child(2) {
      background: #44ce6f;
      color: #fff;
    }
    
    &:hover {
      background: #44ce6f;
      box-shadow: none;
      color: #fff;
    }
  }
}
</style>